import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Download, Crown, Copy } from "lucide-react";
import { loadImage, baseCanvas, goldGradient, drawGlow, drawQrCard } from "@/components/InvitePoster";
import { drawDiamond, drawCornerFrame, drawVerticalText, drawConfetti, drawHeader } from "@/components/RewardPoster";

const KING_CAPTIONS = [
  (d) =>
    `拿下合赢项目交流社区 ${d.period} ${d.label}！当期 ${d.count} 篇项目被录用，额外奖励 ¥${d.reward.toLocaleString()} 已到账。投稿录用奖励最高 ¥188,888，扫海报二维码加入，注册填我邀请码 ${d.inviteCode}，下一期投稿王就是你！`,
  (d) =>
    `连续霸榜！我是合赢项目交流社区 ${d.period} ${d.label}，${d.count} 篇投稿全部录用上架，投稿王奖励 ¥${d.reward.toLocaleString()} 秒到。靠谱项目社区，投稿有奖邀请有奖，扫码加入填邀请码 ${d.inviteCode} 一起搞钱！`,
];

function drawCrownShape(ctx, cx, cy, w, gold) {
  const h = w * 0.62;
  ctx.fillStyle = gold;
  ctx.beginPath();
  ctx.moveTo(cx - w / 2, cy + h / 2);
  ctx.lineTo(cx - w / 2, cy - h * 0.05);
  ctx.lineTo(cx - w * 0.26, cy + h * 0.14);
  ctx.lineTo(cx, cy - h * 0.42);
  ctx.lineTo(cx + w * 0.26, cy + h * 0.14);
  ctx.lineTo(cx + w / 2, cy - h * 0.05);
  ctx.lineTo(cx + w / 2, cy + h / 2);
  ctx.closePath();
  ctx.fill();
  ctx.fillRect(cx - w / 2, cy + h / 2, w, h * 0.16);
  ctx.fillStyle = "#070709";
  [[-0.26, 0.02], [0.26, 0.02], [0, 0.28]].forEach(([dx, dy]) => {
    ctx.beginPath();
    ctx.arc(cx + dx * w, cy + dy * h, w * 0.045, 0, Math.PI * 2);
    ctx.fill();
  });
  drawDiamond(ctx, cx - w / 2, cy - h * 0.12, 9, "#F3E5AB");
  drawDiamond(ctx, cx + w / 2, cy - h * 0.12, 9, "#F3E5AB");
  drawDiamond(ctx, cx, cy - h * 0.5, 11, "#F3E5AB");
}

function drawKing(ctx, qrImg, data) {
  const gold = goldGradient(ctx);
  drawGlow(ctx, 430);
  drawConfetti(ctx, ["#D4AF37", "#F3E5AB", "#AA7C11"]);
  drawCornerFrame(ctx, "rgba(212,175,55,0.55)");
  drawHeader(ctx, gold, "#7c818c");
  drawVerticalText(ctx, "篇篇录用", 96, 420, 58, "700 30px 'Noto Serif SC', serif", "rgba(212,175,55,0.4)");
  drawVerticalText(ctx, "王者加冕", 804, 420, 58, "700 30px 'Noto Serif SC', serif", "rgba(212,175,55,0.4)");
  ctx.textAlign = "center";
  drawCrownShape(ctx, 450, 380, 220, gold);
  ctx.fillStyle = gold;
  ctx.font = "900 108px 'Noto Serif SC', serif";
  ctx.fillStyle = "rgba(122,92,16,0.55)";
  ctx.fillText(data.label, 454, 604);
  ctx.fillStyle = gold;
  ctx.fillText(data.label, 450, 598);
  try { ctx.letterSpacing = "4px"; } catch (e) { /* noop */ }
  ctx.fillStyle = "#8b8f98";
  ctx.font = "22px 'JetBrains Mono', monospace";
  ctx.fillText(`${data.period} · SUBMISSION KING OF THE ${data.week ? "WEEK" : "MONTH"}`, 450, 655);
  try { ctx.letterSpacing = "0px"; } catch (e) { /* noop */ }
  ctx.fillStyle = "#F8F9FA";
  ctx.font = "700 34px 'Noto Serif SC', serif";
  ctx.fillText(`当期录用 ${data.count} 篇 · 篇篇上架「今日项目」`, 450, 725);
  ctx.fillStyle = "#6B7280";
  ctx.font = "18px 'JetBrains Mono', monospace";
  ctx.fillText("KING'S BOUNTY · 投稿王额外奖励已到账", 450, 788);
  ctx.font = "900 116px 'JetBrains Mono', monospace";
  ctx.fillStyle = "rgba(122,92,16,0.55)";
  ctx.fillText(`+¥${data.reward.toLocaleString()}`, 454, 922);
  ctx.fillStyle = gold;
  ctx.fillText(`+¥${data.reward.toLocaleString()}`, 450, 916);
  ctx.fillStyle = "#F8F9FA";
  ctx.font = "25px 'Noto Sans SC', sans-serif";
  ctx.fillText("已到账 · 可提现 USDT", 450, 990);
  ctx.fillStyle = "#6B7280";
  ctx.font = "22px 'Noto Sans SC', sans-serif";
  ctx.fillText(`投稿王 ${data.username} · ${data.date}`, 450, 1036);
  drawQrCard(ctx, qrImg, 450, 1195, 196);
  ctx.fillStyle = gold;
  ctx.font = "700 27px 'Noto Serif SC', serif";
  ctx.fillText("扫码加入 · 下一个投稿王就是你", 450, 1355);
  ctx.fillStyle = "#6B7280";
  ctx.font = "20px 'Noto Sans SC', sans-serif";
  ctx.fillText(`我的邀请码 ${data.inviteCode} · 注册填写各得奖励`, 450, 1400);
  ctx.fillStyle = "#4B5563";
  ctx.font = "19px 'Noto Sans SC', sans-serif";
  ctx.fillText("合赢项目交流社区 · 可靠零风险的赚钱项目", 450, 1452);
}

export default function KingPoster({ open, onClose, bonus, username, inviteCode }) {
  const [imgUrl, setImgUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const [caption, setCaption] = useState("");

  const copyCaption = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    if (open && bonus) {
      setImgUrl(null);
      setCaption("");
      generate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, bonus]);

  const generate = async () => {
    setBusy(true);
    try {
      await document.fonts.ready;
      const inviteLink = `${window.location.origin}/?ref=${inviteCode}`;
      const qrData = await QRCode.toDataURL(inviteLink, {
        width: 600,
        margin: 0,
        color: { dark: "#0A0A0E", light: "#FFFFFF" },
      });
      const qrImg = await loadImage(qrData);
      const { canvas, ctx } = baseCanvas();
      const isWeek = bonus.period_type === "submit_week";
      drawKing(ctx, qrImg, {
        period: bonus.period_key,
        label: isWeek ? "周榜投稿王" : "月度投稿王",
        week: isWeek,
        count: bonus.invites,
        reward: bonus.amount,
        username,
        date: (bonus.created_at || "").slice(0, 10),
        inviteCode,
      });
      setImgUrl(canvas.toDataURL("image/png"));
    } catch (e) {
      toast.error("海报生成失败，请重试");
      onClose();
    } finally {
      setBusy(false);
    }
  };

  const download = async () => {
    if (!imgUrl) return;
    const a = document.createElement("a");
    a.href = imgUrl;
    a.download = `合赢月度投稿王-${bonus.period_key}.png`;
    a.click();
    const text = KING_CAPTIONS[Math.floor(Math.random() * KING_CAPTIONS.length)]({
      period: bonus.period_key,
      label: bonus.period_type === "submit_week" ? "周榜投稿王" : "月度投稿王",
      count: bonus.invites,
      reward: bonus.amount,
      inviteCode,
    });
    setCaption(text);
    const copied = await copyCaption(text);
    if (copied) toast.success("海报已保存，朋友圈文案已复制，直接粘贴即可发布");
    else toast.warning("海报已保存，请长按下方文案手动复制");
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="bg-[#0F0F14] border border-[#D4AF37]/25 text-[#F8F9FA] sm:max-w-md"
        data-testid="king-poster-dialog"
      >
        <DialogTitle className="font-serif-sc text-xl tracking-widest text-center flex items-center justify-center gap-2">
          <Crown className="w-5 h-5 text-[#D4AF37]" /> 投稿王专属海报
        </DialogTitle>
        <DialogDescription className="sr-only">投稿王专属海报，含皇冠、奖励金额与专属邀请二维码</DialogDescription>
        <p className="text-xs text-gray-500 text-center">
          海报内含您的专属邀请二维码，转发朋友圈，好友扫码注册奖励自动归您
        </p>
        <div className="grid place-items-center py-2 min-h-40">
          {busy && <p className="text-sm text-gray-500 py-20">海报绘制中...</p>}
          {!busy && imgUrl && (
            <img
              src={imgUrl}
              data-testid="king-poster-image"
              alt="合赢月度投稿王海报"
              className="w-full max-w-[300px] border border-[#D4AF37]/25"
            />
          )}
        </div>
        <button
          data-testid="king-poster-download-btn"
          onClick={download}
          disabled={!imgUrl}
          className="btn-gold py-2.5 text-sm w-full inline-flex items-center justify-center gap-2"
        >
          <Download className="w-4 h-4" /> 保存海报并复制朋友圈文案
        </button>
        {caption && (
          <div className="border border-[#D4AF37]/20 bg-[#0A0A0E] p-3" data-testid="king-caption-box">
            <div className="flex items-center justify-between mb-2">
              <span className="text-[10px] tracking-widest text-gray-500">朋友圈文案（已自动复制）</span>
              <button
                data-testid="king-caption-copy-btn"
                onClick={async () => {
                  const ok = await copyCaption(caption);
                  if (ok) toast.success("文案已复制");
                  else toast.error("复制失败，请长按手动复制");
                }}
                className="text-[10px] text-[#D4AF37] border border-[#D4AF37]/40 px-2 py-1 inline-flex items-center gap-1 hover:bg-[#D4AF37]/10 transition-colors"
              >
                <Copy className="w-3 h-3" /> 重新复制
              </button>
            </div>
            <p className="text-xs text-gray-300 leading-relaxed select-text" data-testid="king-caption-text">{caption}</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
